import React from "react";
import { CommentOutlined } from "@ant-design/icons";

export default function () {
    return <CommentOutlined />;
}
